import React from "react";
import isEmpty from "../../../../../store/validation/is-Empty";

export const ViewCuisineSection = (props) => {
  return (
    <React.Fragment>
      <div className="row mb-4">
        <div className="col-6">
          <h4 className="font_20_m mb-2">Food Category</h4>
          <p className="font_18_r c_gray">
            {props.data !== undefined && props.data !== null
              ? !isEmpty(props.data?.selected_food_category).length <= 0
                ? "-"
                : !isEmpty(props.data?.selected_food_category) &&
                  props.data?.selected_food_category.map((item, index) => {
                    if (index === 0) {
                      return item.title;
                    } else if (item) {
                      return ", " + item.title;
                    }
                  })
              : "-"}
          </p>
        </div>
        <div className="col-6">
          <h4 className="font_20_m mb-2">Liquor Information</h4>
          <p className="font_18_r c_gray">
            {props.data !== undefined && props.data !== null
              ? !isEmpty(props.data?.selected_liquor_category).length <= 0
                ? "-"
                : !isEmpty(props.data?.selected_liquor_category) &&
                  props.data?.selected_liquor_category.map((item, index) => {
                    if (index === 0) {
                      return item.title;
                    } else if (item) {
                      return ", " + item.title;
                    }
                  })
              : "-"}
          </p>
        </div>
      </div>
      <hr />
      <div className="row mb-4">
        <div className="col-6">
          <h4 className="font_20_m mb-2">Food Type</h4>
          <p className="font_18_r c_gray">
            {props.data !== undefined && props.data !== null
              ? !isEmpty(props.data?.selected_food_type).length <= 0
                ? "-"
                : !isEmpty(props.data?.selected_food_type) &&
                  props.data?.selected_food_type.map((item, index) => {
                    if (index === 0) {
                      return item.title;
                    } else if (item) {
                      return ", " + item.title;
                    }
                  })
              : "-"}
          </p>
        </div>
        <div className="col-6">
          <h4 className="font_20_m mb-2">Personalization</h4>
          <p className="font_18_r c_gray">
            {props?.data?.personalization_information_description !==
              undefined &&
            props?.data?.personalization_information_description !== null
              ? props?.data?.personalization_information_description
              : "-"}
          </p>
        </div>
      </div>
      <hr />
      <div className="row mb-4">
        <div className="col-6">
          <h4 className="font_20_m mb-2">Allergy</h4>
          <p className="font_18_r c_gray">
            {props?.data?.allergicInfoText !== undefined &&
            props?.data?.allergicInfoText !== null
              ? props?.data?.allergicInfoText
              : "-"}
          </p>
        </div>
        <div className="col-6">
          <h4 className="font_20_m mb-2">Nutrition</h4>
          <p className="font_18_r c_gray">
            {props?.data?.nutritionInfoText !== undefined &&
            props?.data?.nutritionInfoText !== null
              ? props?.data?.nutritionInfoText
              : "-"}
          </p>
        </div>
      </div>
      <div className="row mb-4">
        <div className="col-6">
          <h4 className="font_20_m mb-2">Cuisines</h4>
          <p className="font_18_r c_gray">
            {props.data !== undefined && props.data !== null
              ? !isEmpty(props.data?.selected_cusine).length <= 0
                ? "-"
                : !isEmpty(props.data?.selected_cusine) &&
                  props.data?.selected_cusine.map((item, index) => {
                    if (index === 0) {
                      return item.title;
                    } else if (item) {
                      return ", " + item.title;
                    }
                  })
              : "-"}
          </p>
        </div>
      </div>
    </React.Fragment>
  );
};
